import * as React from 'react';
import {useEffect} from 'react';
import {createTransaction} from '../../libs/GsmpiApi';
import {setData} from '../../data/paymentClientSlice';
import {postMessageToParent} from '../../utils/postMessage';
import {PAYMENT_STATUS, POST_MESSAGE_CONTENT_MESSAGE, POST_MESSAGE_TYPE} from '../../common/constants';
import {useDispatch} from 'react-redux';
import debug from 'debug';
import {useNavigate} from 'react-router-dom';

const log = debug("app:WebViewTransactions");

export default function WebViewTransactions() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    window.addEventListener(
      'message',
      event => {
        if (event.data && event.data.type && event.data.type === 'create_transaction') {
          if (event.origin === event.data.sourceOrigin) {
            const paymentRequest = event.data.content;
            paymentRequest.sourceOrigin = event.origin;
            const sourceOrigin = event.origin;
            const domains = event.data.domains;

            createTransaction(paymentRequest).then(result => {
              log(`success to create transactions`);
              dispatch(setData({
                transactionId: result.data.transactionId,
                serviceId: paymentRequest.serviceId,
                merchantName: paymentRequest.merchant.name,
                sourceOrigin: sourceOrigin,
                domains: domains
              }));
              return {transactionId: result.data.transactionId,
                serviceId: paymentRequest.serviceId};
            }).then(({transactionId, serviceId}) => {
              navigate(`/gsmpi-web/webview/bridge?transactionId=${transactionId}&serviceId=${serviceId}`, {replace: true});
            }).catch(() => {
              log(`Failed to create transactions in web view`);
              postMessageToParent({
                type: POST_MESSAGE_TYPE.PAYMENT_RESULT,
                content: {
                  status: PAYMENT_STATUS.FAIL,
                  message: POST_MESSAGE_CONTENT_MESSAGE.PAYMENT_ERROR
                },
                sourceOrigin: sourceOrigin
              });
            });
          }
        }
      },
      false
    );

    postMessageToParent({
      type: POST_MESSAGE_TYPE.READY_TO_CREATE_TRANSACTION,
      content: {},
      sourceOrigin: '*'
    });
  }, []);

  return (<>
    <div>Web View Loading page</div>
  </>);
}